module.exports = __webpack_public_path__ + "static/media/red-bed.576cc76a.svg";